import { Component, OnInit } from '@angular/core';
import { AssetService } from 'app/library-assets/services/asset.service';
import { ManagedClient } from 'app/shared/models/managed-client';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/login/services/auth.service';
import { LibraryAsset } from 'app/library-assets/models/library-asset';
import { AlertService } from 'app/shared/services/alert.service';
import { LibraryAssetResult } from 'app/library-assets/models/library-asset-result';

@Component({
  selector: 'dac-take-asset-external',
  templateUrl: './take-asset-external.component.html',
  styleUrls: ['./take-asset-external.component.scss']
})
export class TakeAssetExternalComponent implements OnInit {
  private _asset:LibraryAsset;
  private _loading:boolean;
  private _client: ManagedClient;
  public saving:boolean;

  constructor(private authService:AuthService, private assetService:AssetService, 
    private route:ActivatedRoute, 
    private router:Router,
    private alertService:AlertService ) { 

    this.authService.getCurrentClient().then((client) => {
			this._client = client;

				// not sure I like this nested, but it does handle duplicate requests for the uid.
			this.route.params.subscribe((params) => {
        let assetId = +params['assetId'];

        this.getAssetResult(client, assetId).then((assetResult) => {
          if (assetResult) {
            this.navigateToAssetResultForClient(client, assetId, assetResult);
          }
          else {
            this.loadAsset(assetId);
          }
        }).catch(error => {
          console.error(error);
          this.loadAsset(assetId);
        });
			});
		}); 

  }

  private navigateToAssetResultForClient(client:ManagedClient, assetId, assetResult) {

    this.router.navigate(['assessments', client.id, 'asset-result', assetResult.id]);
  }

  private getAssetResult(client:ManagedClient, assetId:number) {
    let assignment = client.findAssignmentItemForAssetId(assetId);
    if (assignment && assignment.IsComplete) {
      // grab our result id
      return this.assetService.getAssetResult(assignment.ResultId);
    } else {
      return Promise.resolve(null); // return nothing.
    }
  }

  private loadAsset(assetId:number) {
    this.assetService.getAsset(assetId).then((asset:LibraryAsset) => {
      this._loading = false;
      this._asset = asset;
    })
    .catch((response) => {
        this._loading = false;
        this.alertService.error("Failed to load.  Please check your network connection or contact customer support");	
        console.error(response); 
    })
  }

  public get loading() : boolean {
		return this._loading;
	}

  public get asset() {
    return this._asset;
  }

  ngOnInit() {
  }

  public shouldDisplayExercise() {
    return this._asset && this._asset.type == 'assignment';
  }

  public shouldDisplayArticle() {
    return this._asset && this._asset.type == 'article';
  }

  public submitAsset(assetResult:LibraryAssetResult) {
    // create the exercise results
    this.saving = true;

    // grab all the answers
    let savingMsg = this.alertService.info("Saving....", 600000);
    this.assetService.saveAssetResult(assetResult).then(savedAssetResult => {
      this.alertService.success("Saved answers for " + savedAssetResult.asset.title);
      this.alertService.clearAlert(savingMsg);
      this.navigateToAssetResultForClient(this._client, savedAssetResult.asset.id, savedAssetResult);
    })
    .catch(error => {
      this.alertService.clearAlert(savingMsg);
        console.error("Failed to save json result", error);
        this.saving = false;
        this.alertService.error("There was an error in saving your assignment. Please check your internet connection or try again. If you continue to have problems please contact us via our contact page.", 5000);
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/assessments/take-asset-external/take-asset-external.component.ts